// useCouriersXL - Sprint 44 Fase 3 Vista 6.
// Hook de couriers con load/save/remove/cargarPresets + msg auto-dismiss 4s.
// CRITICO: preserva el CustomEvent('couriers:changed') que escuchan
// ImportacionesList y otros modulos.
import { useCallback, useEffect, useRef, useState } from 'react';
import apiClient from '../../../api/apiClient';

const MSG_AUTO_DISMISS_MS = 4000;

function broadcastChange() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('couriers:changed'));
  }
}

export default function useCouriersXL() {
  const [items, setItems]         = useState([]);
  const [loading, setLoading]     = useState(false);
  const [err, setErr]             = useState(null);
  const [q, setQ]                 = useState('');
  const [msg, setMsg]             = useState(null);
  const [loadingPresets, setLoadingPresets] = useState(false);

  const msgTimer = useRef(null);
  const pushMsg = useCallback((kind, text) => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
    setMsg({ kind, text });
    msgTimer.current = setTimeout(() => setMsg(null), MSG_AUTO_DISMISS_MS);
  }, []);
  useEffect(() => () => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      const r = await apiClient.get('/couriers/?' + params.toString());
      setItems((r && r.data && r.data.items) || []);
    } catch (e) {
      setErr((e && e.message) || 'Error al cargar couriers');
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [q]);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (form) => {
    const payload = {
      nombre: form.nombre,
      url_base_tracking: form.url_base_tracking,
      pais: form.pais,
      logo_url: form.logo_url,
      is_active: !!form.is_active,
    };
    if (form.id) {
      await apiClient.put('/couriers/' + form.id, payload);
    } else {
      await apiClient.post('/couriers/', payload);
    }
    await load();
    broadcastChange();
  }, [load]);

  const remove = useCallback(async (id) => {
    await apiClient.delete('/couriers/' + id);
    await load();
    broadcastChange();
  }, [load]);

  const cargarPresets = useCallback(async () => {
    setLoadingPresets(true);
    try {
      const r = await apiClient.post('/couriers/presets', {});
      const creados = (r && r.data && r.data.creados) || 0;
      pushMsg('ok', creados + ' couriers agregados.');
      await load();
      broadcastChange();
    } catch (e) {
      pushMsg('err', (e && e.message) || 'Error al cargar presets');
    } finally {
      setLoadingPresets(false);
    }
  }, [load, pushMsg]);

  return {
    items, loading, err,
    q, setQ,
    msg, pushMsg, clearMsg: () => setMsg(null),
    save, remove,
    cargarPresets, loadingPresets,
  };
}
